import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Container,Row,Col } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import {
  createSetting,
  updateSetting,
  getSettingWithIDS,
} from "../../slices/thunks";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TextareaInput from "../../common/TextareaInput";

const SettingForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const settingId = location.state?.id;

  const [initialValues, setInitialValues] = useState({
    rules: "", // ✅ Make sure it's "rules" here
  });

  // Fetch rule by ID
  useEffect(() => {
    if (settingId) {
      dispatch(getSettingWithIDS(settingId)).then((res) => {
        const data = res.payload?.data;
        if (data) {
          setInitialValues({
            rules: data.rules || "", // ✅ "rules" from backend
          });
        }
      });
    }
  }, [dispatch, settingId]);

  // Submit form
  const handleSubmit = async (values, { resetForm }) => {
    const payload = {
      rules: values.rules,
    };

    try {
      if (settingId) {
        await dispatch(updateSetting({ id: settingId, payload })).unwrap();
      } else {
        await dispatch(createSetting(payload)).unwrap();
        resetForm();
      }
      navigate("/settings");
    } catch (err) {
      console.error("Error saving rule:", err);
      alert("Failed to save rule.");
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={settingId ? "Edit Rule" : "Add Rule"}
          pageTitle="Settings"
        />
 </Container>
    
       <div className="page-content  justify-content-center align-items-center"></div>
        <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit}>
          {(formik) => (
            <Form className="p-4 border rounded bg-white shadow">
              <div className="mb-3">
              
                <TextareaInput
                label="Common Rule"
                  id="rules"
                  name="rules"
                  className="form-control"
                  rows="5"
                  value={formik.values.rules}
                  onChange={formik.handleChange}
                  placeholder="Enter rule or description..."
                  showHelp
                  required
                  helpText="Provide the rules or guidelines that participants must follow during the quiz."
                />
              </div>
              <Row className="mt-4">
                  <Col lg={12} className="d-flex justify-content-end">
                
              <Button type="submit"  color="primary" >
                {settingId ? "Update Rule" : "Add Rule"}
              </Button>
              </Col>
              </Row>
            </Form>
          )}
        </Formik>
</div>

  );
};

export default SettingForm;
